import { UserService } from '@duck/api-definitions'

export const isAdmin = (user: UserService.User | null): boolean => {
  return user?.role === UserService.UserRole.Admin
}

export const isPartner = (user: UserService.User | null): boolean => {
  return user?.role === UserService.UserRole.Partner
}

export const isAdminOrPartner = (user: UserService.User | null): boolean => {
  return isAdmin(user) || isPartner(user)
}

export const hasRole = (user: UserService.User | null, role: UserService.UserRole): boolean => {
  return user?.role === role
}
